import React, { useRef, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendar } from '@fortawesome/free-solid-svg-icons';
import Flatpickr from 'react-flatpickr';

export function DateField({ setFilterDate }) {
  const [open, setOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState('');
  const calendarRef = useRef(null);

  const handleRemoveFilter = () => {
    setFilterDate('');
    setSelectedDate('');
    setOpen(false);
  };
  const handleSelectFilter = () => {
    setFilterDate(selectedDate);
    setOpen(false);
  };

  return (
    <div>
      Data de solicitação
      <FontAwesomeIcon
        icon={faCalendar}
        onClick={() => setOpen((prev) => !prev)}
        style={{ cursor: 'pointer', marginLeft: '5px' }}
      />
      {open && (
        <div style={{ position: 'absolute' }}>
          <Flatpickr
            ref={calendarRef}
            required
            className="d-none"
            value={selectedDate}
            style={{ borderBottom: 'none', textShadow: '-1px 1px 1px #000' }}
            placeholder="Selecione a data"
            options={{
              locale: {
                months: {
                  longhand: [
                    'Janeiro',
                    'Fevereiro',
                    'Março',
                    'Abril',
                    'Maio',
                    'Junho',
                    'Julho',
                    'Agosto',
                    'Setembro',
                    'Outubro',
                    'Novembro',
                    'Dezembro',
                  ],
                  shorthand: [
                    'Jan',
                    'Fev',
                    'Mar',
                    'Abr',
                    'Mai',
                    'Jun',
                    'Jul',
                    'Ago',
                    'Set',
                    'Out',
                    'Nov',
                    'Dez',
                  ],
                },
                weekdays: {
                  longhand: [
                    'Domingo',
                    'Segunda-feira',
                    'Terça-feira',
                    'Quarta-feira',
                    'Quinta-feira',
                    'Sexta-feira',
                    'Sábado',
                  ],
                  shorthand: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
                },
              },
              inline: true,
              dateFormat: 'd/m/Y',
              allowInput: true,
              altInput: true,
              altFormat: 'd/m/Y',
              onChange: (e) => setSelectedDate(e[0]),
            }}
          />
          <div style={{ marginTop: '1.5px' }}>
            <button
              onClick={handleRemoveFilter}
              className="btnCalendar btnClear"
            >
              Limpar
            </button>
            <button
              onClick={handleSelectFilter}
              className="btnCalendar btnSelect"
            >
              Selecionar
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
